import { ChatPage, type ChatPageProps } from "../chat/ChatPage.js";
import { IntelligencePage } from "../intelligence/IntelligencePage.js";
import { SearchPage } from "../search/SearchPage.js";
import { SkillsPage, type SkillsPageProps } from "../skills/SkillsPage.js";
import type { WorkspaceView } from "./workspaceView.js";

export function WorkspaceRouter({
  workspaceView,
  chatPageProps,
  skillsPageProps
}: {
  workspaceView: WorkspaceView;
  chatPageProps: ChatPageProps;
  skillsPageProps: SkillsPageProps;
}) {
  return (
    <>
      <ChatPage {...chatPageProps} />
      {workspaceView === "search" && <SearchPage />}
      {workspaceView === "intelligence" && <IntelligencePage />}
      {workspaceView === "skills" && <SkillsPage {...skillsPageProps} />}
    </>
  );
}
